import { useMemo } from "react";

export interface CdsSourceSettingsText {
  unauthorisedWarningText: string;
  environmentLabelText: string;
  dataToLoadLabelText: string;
  dataToLoadPlaceholderText: string;
  dataToLoadHintText: string;
  statusesLabelText: string;
  statusesPlaceholderText: string;
  statusesHintText: string;
  doneStatusLabelText: string;
  doneStatusPlaceholderText: string;
  doneStatusHintText: string;
  doneStatusInactiveWarningText: string;
  dueDateFieldLabelText: string;
  dueDateFieldPlaceholderText: string;
  dueDateFieldHintText: string;
  assignedToFieldLabelText: string;
  assignedToFieldPlaceholderText: string;
  assignedToFieldHintText: string;
  tagsFieldLabelText: string;
  tagsFieldPlaceholderText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingEntityDefinitionsText: string;
  loadingStatusesText: string;
  loadingDateAttributesText: string;
  loadingAssignedToAttributesText: string;
  loadingAttributesText: string;
  loadErrorText: string;
}

export const useCdsSourceSettingsText = (
  t: (key: string) => string,
): CdsSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.cds.${key}`);

    return {
      unauthorisedWarningText: tKey("unauthorisedWarning"),
      environmentLabelText: tKey("environmentLabel"),
      dataToLoadLabelText: tKey("dataToLoadLabel"),
      dataToLoadPlaceholderText: tKey("dataToLoadPlaceholder"),
      dataToLoadHintText: tKey("dataToLoadHint"),
      statusesLabelText: tKey("statusesLabel"),
      statusesPlaceholderText: tKey("statusesPlaceholder"),
      statusesHintText: tKey("statusesHint"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      doneStatusHintText: tKey("doneStatusHint"),
      doneStatusInactiveWarningText: tKey("doneStatusInactiveWarning"),
      dueDateFieldLabelText: tKey("dueDateFieldLabel"),
      dueDateFieldPlaceholderText: tKey("dueDateFieldPlaceholder"),
      dueDateFieldHintText: tKey("dueDateFieldHint"),
      assignedToFieldLabelText: tKey("assignedToFieldLabel"),
      assignedToFieldPlaceholderText: tKey("assignedToFieldPlaceholder"),
      assignedToFieldHintText: tKey("assignedToFieldHint"),
      tagsFieldLabelText: tKey("tagsFieldLabel"),
      tagsFieldPlaceholderText: tKey("tagsFieldPlaceholder"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingEntityDefinitionsText: tKey("loadingEntityDefinitions"),
      loadingStatusesText: tKey("loadingStatuses"),
      loadingDateAttributesText: tKey("loadingDateAttributes"),
      loadingAssignedToAttributesText: tKey("loadingAssignedToAttributes"),
      loadingAttributesText: tKey("loadingAttributes"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
